import { render } from "./ShortListPlayerSelection.vue?vue&type=template&id=62f8e941"
import script from "./ShortListPlayerSelection.vue?vue&type=script&lang=js"
export * from "./ShortListPlayerSelection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__